<template>
    <div class="invoice-card" :class="cardClass">
      <div class="invoice-card__left">
        <div class="invoice-card__date">{{ formattedInvoiceDate }}</div>
        <div class="invoice-card__seperator">—</div>
        <div class="invoice-card__number">{{ invoice_no.displayValue }}</div>
        <div class="invoice-card__amount">({{ group_total.displayValue }}€)</div>
      </div>
      <div class="invoice-card__right">
        <div class="invoice-card__due-info">
            <span v-if="isPaid && paid_date.displayValue" class="invoice-card__paid-label">
              {{$t("LBL_PAID")}} {{ formattedPaidDate }}
            </span>
            <span v-else-if="!isPaid && !isCanceled && !isCredit" class="invoice-card__due-label">
                {{$t("LBL_DUE")}} {{ formattedDueDate }}
            </span>
        </div>
        <div class="badge invoice-card__status">
          {{ invoicestatus.displayValue }}
        </div>
        <button class="btn btn-primary invoice-card__download" @click.stop="downloadInvoice" :disabled="isDownloading">
          <i class="zmdi zmdi-cloud-download"></i>
          <span>{{$t("LBL_DOWNLOAD")}}</span>
        </button>
      </div>
    </div>
</template>

<script>
    export default {
        props: {
            invoice_no: {
                type: Object,
                default: () => ({value: '', displayValue: ''})
            },
            invoicedate: {
                type: Object,
                default: () => ({value: '', displayValue: ''})
            },
            duedate: {
                type: Object,
                default: () => ({value: '', displayValue: ''})
            },
            paid_date: {
                type: Object,
                default: () => ({value: '', displayValue: ''})
            },
            invoicestatus: {
                type: Object,
                default: () => ({value: '', displayValue: ''})
            },
            group_total: {
                type: Object,
                default: () => ({value: '', displayValue: ''})
            },
            record_id: {
                type: [String, Number],
                default: ''
            }
        },

        data() {
            return {
                isDownloading: false
            }
        },

        computed: {
            isCanceled() {
                return this.invoicestatus.value && this.invoicestatus.value.toLowerCase() === 'canceled'
            },

            isCredit() {
              return this.invoicestatus.value && this.invoicestatus.value.toLowerCase() === 'credit'
            },

            isPaid() {
                return this.invoicestatus.value && this.invoicestatus.value.toLowerCase() === 'paid'
            },

            cardClass() {
              return `invoice-card--${this.invoicestatus.value.toLowerCase().replace(/\s+/, '-')}`
            },

            formattedInvoiceDate() {
              return this.getLocalDate(this.invoicedate.value)
            },

            formattedPaidDate() {
              return this.getLocalDate(this.paid_date.value)
            },

            formattedDueDate() {
              return this.getLocalDate(this.duedate.value)
            }
        },

        methods: {
            async downloadInvoice() {
                if (!this.record_id || this.isDownloading) return;

                try {
                    this.isDownloading = true;
                    
                    const response = await Api.invoiceDownload(this.record_id);

                    // Create blob and trigger download
                    const blobData = response.data || response;
                    const blob = new Blob([blobData], { type: 'application/octet-stream' });
                    const link = document.createElement('a');
                    const url = window.URL.createObjectURL(blob);
                    
                    link.href = url;
                    link.download = `invoice-${this.invoice_no.displayValue || this.record_id}.pdf`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                    
                } catch (error) {
                    console.error('Invoice download failed:', error);
                    alert('Failed to download invoice. Please try again.');
                } finally {
                    this.isDownloading = false;
                }
            }
        }
    }
</script><style lang="scss">@import "@/assets/scss/components/Invoice/List/_listitem.scss";</style>